import { render, staticRenderFns } from "./VeBoxSpacingPicker.vue?vue&type=template&id=4e6282bc&scoped=true"
import script from "./VeBoxSpacingPicker.vue?vue&type=script&lang=js"
export * from "./VeBoxSpacingPicker.vue?vue&type=script&lang=js"
import style0 from "./VeBoxSpacingPicker.vue?vue&type=style&index=0&id=4e6282bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6282bc",
  null
  
)

export default component.exports